<template>
  <!-- wrapper를 relative로, width는 wrapper에 적용 -->
  <div class="relative" :class="width">
    <div :class="boxClass">
      <div class="flex gap-1 px-2 w-full items-center">
        <SearchIcon
          class="shrink-0"
          :width="16"
          :height="16"
          color="text-content-basic-2"
          weight="REGULAR"
        />
  
        <input
          :type="inputtype || 'text'"
          :placeholder="placeholder"
          :value="inputValue"
          :class="inputClass"
          @keyup.enter="searchEvent"
          @input="onInput"
          @focusin="showOptions = true"
          @focusout="showOptions = false"
        />
      </div>

          <button
            type="button"
            @click="searchEvent"
            class="font-caption-md-medium text-primary-3 border-l-1 border-border-basic-2 h-full px-2 hover:bg-background-basic-3"
          >
            Search
          </button>
    </div>

    <ul
      v-if="filteredOptions.length"
      :class="[selectOptionsClass, 'ds-scrollbar']"
      class="p-2 rounded-2"
    >
      <li
        v-for="(option, idx) in filteredOptions"
        :key="option.value ?? option.text ?? idx"
        class="px-2 py-3 rounded-2 w-full hover:bg-background-basic-3 cursor-pointer"
        @mousedown.prevent="selectOption(option)"
      >
      <p class="font-body-sm-regular w-full break-all">
        {{ option.text }}
      </p>
        
      </li>
    </ul>
  </div>
</template>

<script>
import SearchIcon from './icon/search.vue'

export default {
  name: 'SearchInput',
  components: { SearchIcon },
  props: {
    modelValue: { type: [String, Number], default: '' },
    placeholder: { type: String, default: '' },
    inputtype: { type: String, default: 'text' },
    size: {
      type: String,
      default: 'MD',
      validator: v => ['MD', 'LG'].includes(String(v).toUpperCase()),
    },
    // width는 wrapper에만 적용
    width: { type: String, default: 'w-60' },
    options: {
      type: Array,
      default: () => [] // [{ text, value }]
    },
    optionClickEvent: Boolean,
  },
  emits: ['update:modelValue', 'searchEvent'],
  data() {
    return {
      boxBaseClass: [
        'flex items-center overflow-hidden',
        'bg-background-basic-1 rounded-2 cursor-text',
        'border border-border-basic-2',
        'focus-within:border-primary-3',
        'transition-colors'
      ],
      boxClassMap: {
        LG: 'h-[2.75rem]',
        MD: 'h-[2.25rem]',
      },
      inputBaseClass: [
        'w-full p-0 border-none focus:outline-none focus:ring-0',
        'text-content-basic-1 placeholder:text-content-basic-3'
      ],
      inputTextMap: {
        LG: 'font-body-sm-regular',
        MD: 'font-caption-md-regular',
      },
      optionsClass: 'absolute left-0 right-0 z-10 mt-1 bg-background-basic-1 rounded-02 shadow-lg max-h-60 overflow-auto',
      optionsTextClass: 'text-content-basic-1',
      showOptions: false,
      inputValue: String(this.modelValue ?? ''),
    }
  },
  watch: {
    modelValue(val) {
      this.inputValue = String(val ?? '')
    }
  },
  computed: {
    normalizedSize() { return String(this.size).toUpperCase() },
    iconSize() { return this.size.toUpperCase() === 'LG' ? 24 : 20 },
    boxClass() {
      const self = this;
      const boxBaseClass = self.boxBaseClass;
      const size = self.size.toUpperCase();
      const boxClass = self.boxClassMap[size] || '';
      return [...boxBaseClass, boxClass].join(' ')
    },
    inputClass() {
      const self = this;
      const inputBaseClass = self.inputBaseClass;
      const size = self.size.toUpperCase();
      const inputTextClass = self.inputTextMap[size] || '';
      return [...inputBaseClass, inputTextClass].join(' ')
    },
    selectOptionsClass() {
      const self = this;
      const optionsClass = self.optionsClass;
      const optionsTextClass = self.optionsTextClass;
      return [optionsClass, optionsTextClass].join(' ')
    },
    filteredOptions() {
        const self = this;
        const keyword = (self.inputValue || '').trim().toLowerCase()
        if (!self.showOptions || !keyword) {
            return [];
        }
        return (this.options || []).filter(o =>
          String(o?.text ?? '').toLowerCase().includes(keyword)
        )
    },
      
  },
  methods: {
    onInput(event) {
      const self = this;
      self.showOptions = event.target.value == null || event.target.value == '' ? false : true;
      self.inputValue = event.target.value;
      self.$emit('update:modelValue', self.inputValue);
    },
    selectOption(option) {
        const self = this;
        self.inputValue = option.text;
        self.showOptions = false;

        self.$emit('update:modelValue', self.inputValue);
        if (self.optionClickEvent) {
            self.searchEvent();
        }
    },
    searchEvent() {
        const self = this;
        self.showOptions = false;

        self.$emit('searchEvent');
    },
    getSearchedText() {
      const self = this;
      return self.inputValue;
  },

  setInputText(text) {
      const self = this;
      self.inputValue = String(text ?? '');
  },
    getSearchedValues() {
        const self = this;
        if (self.inputValue == null || self.inputValue == '' ) {
            return null;
        }
        if (self.options[0].text == null && self.options.length==1){
            return self.inputValue;
        }

        return self.options.filter((option) => option.text.toLowerCase().includes(this.inputValue.toLowerCase())).map((option) => option.value);
    },
  },
}
</script>